const C = Math.cos(Math.PI / 6);
const S = Math.sin(Math.PI / 6);

export default function WireBox({ L = 120, W = 80, H = 60, className = "" }) {
  const mx = Math.max(L, W, H, 1);
  const sc = 112;
  const l = (L / mx) * sc;
  const w = (W / mx) * sc;
  const h = (H / mx) * sc;
  const P = (x, y, z) => [(y - x) * C, (x + y) * S - z];
  const A = P(0, 0, 0), B = P(l, 0, 0), Cc = P(l, w, 0), D = P(0, w, 0);
  const E = P(0, 0, h), F = P(l, 0, h), G = P(l, w, h), Hp = P(0, w, h);
  const ox = 170;
  const oy = 24 + h;
  const pt = (p) => `${(p[0] + ox).toFixed(1)},${(p[1] + oy).toFixed(1)}`;
  const mid = (p, q) => [(p[0] + q[0]) / 2 + ox, (p[1] + q[1]) / 2 + oy];
  const label = (p, txt) => (
    <text x={p[0]} y={p[1]} textAnchor="middle" className="fill-neutral-400 font-mono" fontSize="9">
      {txt}
    </text>
  );
  return (
    <svg viewBox="0 0 340 260" className={className} role="img" aria-label="Aperçu filaire 3D de la pièce">
      <polygon points={[E, F, G, Hp].map(pt).join(" ")} fill="#EA580C" fillOpacity="0.07" />
      <g stroke="#0A0A0A" strokeOpacity="0.28" strokeWidth="1" fill="none" strokeDasharray="3 4">
        <line x1={pt(A).split(",")[0]} y1={pt(A).split(",")[1]} x2={pt(D).split(",")[0]} y2={pt(D).split(",")[1]} />
        <line x1={pt(A).split(",")[0]} y1={pt(A).split(",")[1]} x2={pt(Hp).split(",")[0]} y2={pt(Hp).split(",")[1]} />
      </g>
      <g stroke="#0A0A0A" strokeOpacity="0.65" strokeWidth="1.2" fill="none">
        <polygon points={[A, B, Cc, D].map(pt).join(" ")} />
        <polygon points={[E, F, G, Hp].map(pt).join(" ")} stroke="#EA580C" strokeWidth="1.3" />
        <line x1={pt(B).split(",")[0]} y1={pt(B).split(",")[1]} x2={pt(F).split(",")[0]} y2={pt(F).split(",")[1]} />
        <line x1={pt(Cc).split(",")[0]} y1={pt(Cc).split(",")[1]} x2={pt(G).split(",")[0]} y2={pt(G).split(",")[1]} />
        <line x1={pt(D).split(",")[0]} y1={pt(D).split(",")[1]} x2={pt(Hp).split(",")[0]} y2={pt(Hp).split(",")[1]} />
        <line x1={pt(A).split(",")[0]} y1={pt(A).split(",")[1]} x2={pt(E).split(",")[0]} y2={pt(E).split(",")[1]} />
      </g>
      {label(mid(B, Cc), `L ${Math.round(L)}`)}
      {label(mid(Cc, D), `l ${Math.round(W)}`)}
      {label(mid(B, F), `H ${Math.round(H)}`)}
    </svg>
  );
}
